import { useEffect, useMemo, useState } from "react";

export const useSearchableList = ({
  defaultValue,
  alternativeNewValue,
  autoFocus,
  maxLength,

  onAutoFocus,
  onFocus,
  onBlur,
  onChange,
  
  onFilterChange,
  getOptionDisabled,
  errorOnEmpty,
}) => {
  const [ searchValue, setSearchValue ] = useState(defaultValue);
  const [ hasValueIsUsedError, setUsedValue ] = useState(false);
  const [ focused, setFocused ] = useState(autoFocus);
  const [ hadAutofocus, setHadAutofocus ] = useState(autoFocus);
  const [ hadInteraction, setHadInteraction ] = useState(autoFocus);

  const [ anchor, setAnchor ] = useState(null);
  
  const hasEmptyError = useMemo(() => (
    errorOnEmpty && !searchValue?.length && !hadAutofocus
  ), [ errorOnEmpty, searchValue, hadAutofocus ]);

  useEffect(() => {
    if (autoFocus) {
      setFocused(autoFocus);
      setHadAutofocus(autoFocus);
      if(onAutoFocus) onAutoFocus();
    }
  }, [ autoFocus ]);

  useEffect(() => {
    setSearchValue(defaultValue?.replace(/<([.\n])*?>/g, ""));
    setHadInteraction(false);
  }, [defaultValue]);

  useEffect(() => {
    if (focused !== undefined && onFocus)
      onFocus();
  }, [ focused ]);

  useEffect(() => {
    if (focused && searchValue.length >= 3)
      if(onFilterChange)
        onFilterChange(searchValue);
    if (
      focused &&
      searchValue.length &&
      searchValue !== defaultValue &&
      getOptionDisabled
    )
      setUsedValue(getOptionDisabled(searchValue));
  }, [ searchValue ]);

  const handleInputChange = (v) => {
    setSearchValue(v.slice(0, maxLength));
    if(!hadInteraction)
      setHadInteraction(true);
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleNameAccept = () => {
    if (focused) {
      setFocused(false);
      setHadAutofocus(false);
      setHadInteraction(false);

      const hasValue = searchValue && searchValue !== defaultValue;
      
      if(!hasValueIsUsedError && !hasEmptyError && (hasValue || alternativeNewValue)) {
        if(onChange) {
          const hasError = onChange({ name: hasValue ? searchValue : alternativeNewValue }, true);
          if(hasError)
            setSearchValue(defaultValue);
        }
        return;
      }
      
      if (hasValueIsUsedError && defaultValue) {
        setUsedValue(false);
        setSearchValue(defaultValue);
      } else {
        if(hasEmptyError && defaultValue)
          setSearchValue(defaultValue);
        if(onBlur) onBlur();
      }
    }
  };

  const looseFocus = () => {
    setFocused(false);
    setHadAutofocus(false);
  };

  console.log(hasValueIsUsedError, hasEmptyError)

  const inputProps = {
    ref: setAnchor,
    focused,
    value: searchValue,
    error: hasValueIsUsedError || hasEmptyError,
    onChange: handleInputChange,
    onFocus: handleFocus,
    onAccept: handleNameAccept,
    confirmOnEnter: true,
    acceptOnClickAway: true,
  };

  const containerProps = {
    show: focused,
    anchor: anchor,
  };

  return {
    inputProps,
    containerProps,
    hadAutofocus,
    hadInteraction,
    looseFocus,
  };
};
